(ns manage.adset-activation-table.db
  (:require [common.db.table.backend :refer [map->RemoteBackend]]
            [common.db.table.core :refer [register-table]]))

(def backend
  (map->RemoteBackend
   {:on-init [:resource.adset-activation/get-all]
    :on-change [:resource.adset-activation/get-all]}))

(register-table
 {:namespace :table.adset-activation
  :value-sub [:resource.adset-activation/all]
  :initial-sort {:column :updatedAt :direction :desc}
  :initial-search {:column :name :term ""}
  :initial-page {:size 10 :cursor 0}
  :backend backend})

